exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hide-on-paypal[data-v-10846322]{display:none!important}", ""]);

// exports
